import { getSetupData } from '../additiv-services/setup';

const setupData = getSetupData();

export const getCurrentEnv = () => {
    const suffix = setupData.DMS_URL_SUFFIX;

    if (suffix.toLowerCase().includes('dev') && global.window.location.hostname === 'localhost') { return 'localhost'; }
    if (suffix.toLowerCase().includes('dev')) { return 'dev'; }
    if (suffix.toLowerCase().includes('sandbox')) return 'sit';
    if (suffix.toLowerCase().includes('uat')) return 'uat';

    return 'production';
};
